export type CydProductsTableRow = Record<string, unknown>;

/** Alinea filas del RPC/API con las columnas que espera TabbedTableRenderer. */
export function normalizeCydTableRow(row: CydProductsTableRow): CydProductsTableRow {
  const totalSold = row.total_sold ?? row.quantity_sold ?? row.totalSold ?? 0;
  const totalCyd = row.total_cyd ?? row.boris_quantity ?? row.totalCyd ?? 0;
  const cydRate = row.cyd_rate ?? row.rate_cyd ?? row.cydRate ?? 0;

  return {
    ...row,
    total_sold: totalSold,
    total_cyd: totalCyd,
    cyd_rate: cydRate,
  };
}

export function normalizeCydTableRows(rows: CydProductsTableRow[]): CydProductsTableRow[] {
  return rows.map(normalizeCydTableRow);
}

export function sortCydTableRowsByRateDesc(rows: CydProductsTableRow[]): CydProductsTableRow[] {
  return normalizeCydTableRows(rows).sort(
    (a, b) => Number(b.cyd_rate ?? 0) - Number(a.cyd_rate ?? 0)
  );
}
